/* eslint-disable max-lines-per-function */
import { useDtfStore } from "../../store";
import { cn } from "tailwind-variants";
import Headline from "../components/Headline.vue";
import Section from "../components/Section.vue";
import { List, ListItem } from "../components/List/index";
import RedrawNotes from "../../RedrawNotes.vue";
import PriceLabel from "../components/PriceLabel.vue";
import CustomComparison from "./CustomComparison.vue";
import "./Custom.scss";

export default function Custom({ artwork, reorderEnabled, index, ...restProps }) {
  const store = useDtfStore();

  function showRedrawNote() {
    return store.showRedrawUI;
  }

  return (
    <>
      <Headline
        className={cn(
          "custom__headline scope-c603d1c4",
          reorderEnabled && "custom__headline--large-padding"
        )}
        slots={{
          title: () => (
            <div className="custom__title scope-c603d1c4">
              {" "}
              Custom edits, done for you.{" "}
              <PriceLabel
                className="scope-c603d1c4"
                artwork={artwork}
                reorderEnabled={reorderEnabled}
                showRetailPrice={false}
                data-testid="price-label"
              />
            </div>
          ),
          subtitle: () => (
            <div className="custom__subtitle scope-c603d1c4">
              {" "}
              Tell us what you want! Our expert team will adjust your design and make sure it's just
              right for printing.{" "}
            </div>
          )
        }}
        data-testid="custom-headline"
      />
      <Section className="custom__list-section scope-c603d1c4" data-testid="custom-list-section">
        <List className="scope-c603d1c4" long={true} data-testid="list">
          <ListItem className="scope-c603d1c4" showMonetization={true} data-testid="list-item">
            {"Same-day turnaround"}
          </ListItem>
          <ListItem className="scope-c603d1c4" showMonetization={true} data-testid="list-item-1">
            {"Precise color changes"}
          </ListItem>
          <ListItem className="scope-c603d1c4" showMonetization={true} data-testid="list-item-2">
            {"Custom background removal"}
          </ListItem>
          <ListItem className="scope-c603d1c4" showMonetization={true} data-testid="list-item-3">
            {"Fine-tuned adjustments"}
          </ListItem>
          <ListItem className="scope-c603d1c4" kind="highlight" data-testid="list-item-4">
            <a
              className="scope-c603d1c4"
              href="/jiffy-transfers-FAQs#design-quality-guarantee"
              target="_blank"
              data-testid="custom-a"
            >
              {" "}
              PrintPerfect Guarantee{" "}
            </a>
            {"included"}
          </ListItem>
        </List>
      </Section>
      {showRedrawNote() ? (
        <RedrawNotes
          className="scope-c603d1c4"
          index={index}
          enhancementNote={artwork.enhancementNote}
          disabled={!artwork.enhancementCompleted}
          data-testid="redraw-notes"
        />
      ) : null}
      <Section className="custom__comparison scope-c603d1c4" data-testid="custom-comparison">
        <CustomComparison className="scope-c603d1c4" data-testid="custom-comparison-1" />
      </Section>
    </>
  );
}
